module.exports = __webpack_public_path__ + "static/media/logo-auati.08a521e6.svg";